import { merge } from 'lodash'
import api from '@/api'

export default {
  namespaced: true,
  state: {
    statuses: [],
    fetching: false
  },
  actions: {
    async fetch ({ state, commit }, { type, identifier }) {
      commit('setFetch', true)
      try {
        const statuses = await api.getOrderStatuses(type, identifier)
        statuses.forEach(status => {
          status.module = {type, identifier}
          commit('addStatus', status)
        })
      } catch (error) {
        commit('clearStatuses')
      } finally {
        commit('setFetch', false)
      }
    }
  },
  getters: {
    findByModuleTypeAndIdentifier: state => (type, identifier) => state.statuses.filter(status =>
      status.module.identifier === identifier &&
      status.module.type === type)
  },
  mutations: {
    setFetch (state, flag) {
      state.fetching = flag
    },
    clearStatuses (state) {
      state.statuses = []
    },
    addStatus (state, statusToAdd) {
      const status = state.statuses.find(status =>
        status.code === statusToAdd.code &&
        status.module.identifier === statusToAdd.module.identifier &&
        status.module.type === statusToAdd.module.type)

      if (status) {
        merge(status, statusToAdd)
      } else {
        state.statuses.push(statusToAdd)
      }
      state.statuses = [...state.statuses]
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/orderStatuses.js